export const TABS = ['UPCOMING', 'PAST'] as const;
export type TourTab = (typeof TABS)[number];
export const DEFAULT_ACTIVE_TAB: TourTab = TABS[0];

type TourTabsProps = {
    activeTab: TourTab;
    onTabChange: (tab: TourTab) => void;
};

export const TourTabs = ({ activeTab, onTabChange }: TourTabsProps) => (
    <ul data-testid='tour-tabs' className='rounded-none nav nav-pills nav-pills-filled nav-justified'>
        {TABS.map(tab => (
            <li key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => onTabChange(tab)}>
                <span>{tab}</span>
            </li>
        ))}
    </ul>
);
